import script from "./ScrollablePanels2.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollablePanels2.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollablePanels2.vue?vue&type=style&index=0&id=e36a12fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e36a12fa"]])

export default __exports__